import * as React from "react"
import styled from "@emotion/styled"
import { theme, rr } from "../../styles/styleGuide"
import intro from "../../assets/mobile/videos/heroIntro.mp4"
import loop from "../../assets/mobile/videos/heroLoop.mp4"
var color = theme.color,
  font = theme.font

function Hero() {
  React.useEffect(() => {
    var intro = document.querySelector("#hero #intro") as HTMLVideoElement

    if (intro) {
      intro.addEventListener("ended", () => {
        intro.parentElement?.removeChild(intro)
        intro.removeEventListener("ended", () => {})
        intro.style.display = "none"
      })
    }
  }, [])
  return (
    <Container id="hero">
      <BackVideo className="video" id="loop" muted loop src={loop} playsInline />
      <BackVideo className="video" id="intro" src={intro} muted playsInline />
      <Title />
      <Border />
      <ScrollIcon />
    </Container>
  )
}
const Container = styled.div`
  position: absolute;
  bottom: 0;
  width: 100vw;
  ${rr("height", "vh", 90)}
  background-color: #fff;
  overflow: hidden;
`
const Border = styled.div`
  position: absolute;
  pointer-events: none;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100%;
  ${rr("border", ` solid ${color.black}`, "2.4vw", "2.4vw", "2.1vw")}
  box-sizing: border-box;
`
const Title = () => {
  const Figure = styled.span`
    display: inline-block;
    color: inherit;
    font-size: inherit;
    margin: 0;
    ${font.title};
  `
  const Upper = styled.h1`
    font-size: 2.55em;
    margin: 0;
    margin-bottom: -0.2em;
    color: ${color.black};
    overflow: hidden;
  `
  const Lower = styled.h1`
    font-size: 1.7em;
    margin: 0;
    color: ${color.black};
    overflow: hidden;
  `
  const TagText = styled.span`
    font-size: 0.58em;
    position: relative;
    margin-right: 0.5em;
    color: ${color.redInverse};
    overflow: hidden;
    mix-blend-mode: difference;
  `
  const TagLine = styled.div`
    position: relative;
    display: inline-block;
    ${rr("top", "vh", -1)}
    transform: translateY(10%);
    width: 17vw;
    ${rr("height", "vh", 0.4, 0.5, 0.6)}
    background-color: ${color.redInverse};
    mix-blend-mode: difference;
  `
  const TagContainer = styled.div`
    display: block;
    margin-top: 3vw;
  `

  const Holder = styled.div`
    ${rr("font-size", "vw", 11, 10, 9)}
    height: 90%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  `

  const Split = (text: string) => {
    return text.split("").map((e: string, key: number) => (
      <Figure className="figure" key={key}>
        {e}
      </Figure>
    ))
  }

  return (
    <Holder id="title">
      <Upper className="upper">{Split("Abdalla")}</Upper>
      <Lower className="lower">{Split("al-hossainy")}</Lower>
      <TagContainer className="tag-line">
        <TagText className="text">
          {Split("web")}
          <b> </b>
          {Split("designer")}
          <b> </b>
          {Split("&")}
          <b> </b>
          {Split("Developer")}
        </TagText>
        <TagLine className="line" />
      </TagContainer>
    </Holder>
  )
}
const BackVideo = styled.video`
  position: absolute;
  bottom: 0;
  /* ${rr("bottom", "vh", 2)} */
  left: 0px;
  width: 100vw;
`
const ScrollIcon = () => {
  const Holder = styled.div`
    position: absolute;
    bottom: 4vh;
    width: 100vw;
    height: 20vw;
    /* background-color: #04d350; */
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    mix-blend-mode: difference;
  `
  const Bar = styled.div`
    /* border: 1px solid #000; */

    border-radius: 60px;
    ${rr("border", ` solid ${color.redInverse}`, "0.6vw")}
    ${rr("width", "vw", 5)}
    ${rr("height", "vw", 14)}
  `

  const Circle = styled.div`
    position: absolute;
    border-radius: 50%;
    width: 2vw;
    height: 2vw;
    background-color: ${color.redInverse};
    animation: moves 1.5s infinite reverse;

    @keyframes moves {
      from {
        transform: translateY(-150%);
      }

      to {
        transform: translateY(150%);
        opacity: 0.1;
      }
    }
  `
  return (
    <Holder className="scroll-icon">
      <Bar />
      <Circle />
    </Holder>
  )
}

export default Hero
